import { TFilterValue } from '../../types';

export const formatObjectToFilterUrl = (objectFilterValues: TFilterValue) => {
  const filterValues: { name: string; value: string }[] = [];

  Object.entries(objectFilterValues)?.map(([key, value]) => {
    return filterValues.push({
      name: key,
      value,
    });
  });

  return filterValues;
};
